import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMSmallTable } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";
import { getOeOwnerLabel } from "../../../utils/get-owner-label";

/** Adds the project team card (#2222). */
export function addProjectTeamCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";

  /**
   * Add the project team component to the view.
   */
  const projectTeamComponent = view.addComponent({
    component: PMSmallTable,
    layoutProps: {
      componentId: "projectTeamComponent",
      labels: ["team"],
      description:
        getLocalizedMessage(language, "showsProjectTeam") ||
        "Shows the project Team.",
      title: getLocalizedMessage(language, "projectTeam") || "Project Team",
    },
  });

  projectTeamComponent.mapState(({ currentReport, settings, language }) => {
    return {
      showInfoIcon: false,
      showMenuIcon: false,
      icon: "InfoOutlined",
      title: `${
        settings?.configuration?.projectName ??
        getLocalizedMessage(language || "en", "project") ??
        "Project"
      } ${getLocalizedMessage(language || "en", "team") ?? "Team"}`,

      items: [
        {
          label: getOeOwnerLabel(
            settings?.configuration?.projectName,
            `${
              settings?.configuration?.projectName ??
              getLocalizedMessage(language || "en", "project") ??
              "Project"
            } ${getLocalizedMessage(language || "en", "owner") ?? "Owner"}`
          ),
          value: currentReport?.project?.owner ?? "",
          cutValueAfter: 20,
          chipColor: theme.palette.secondary.main,
          chipTextColor: theme.palette.primary.main,
        },
      ],
      fixedHeight: "134px",
    };
  });

  projectTeamComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "itemBasic")
        ?.find((field) => field.fieldName === "owner")?.enabled === true
  );
}
